import config from '@/config'

const loadingOptions = {
  lock: true,
  text: 'Loading',
  spinner: 'el-icon-loading',
  background: 'rgba(0, 0, 0, 0.7)'
}

export default {
  data () {
    return {
      isMobile: false
    }
  },
  created () {
    this.isMobile = this.isCheckMobile()
  },
  methods: {
    showLoading: function () {
      this.$loading(loadingOptions)
    },
    closeLoading: function () {
      this.$loading(loadingOptions).close()
    },
    isCheckMobile () {
      const width = window.innerWidth
      return width - 1 < config.MOBILE_WIDTH
    },

    confirmWarning (title, message, callBackConfirm, callBackCancel) {
      this.$confirm(message, title, {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        closeOnPressEscape: false,
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        callBackConfirm()
      }).catch(() => {
        callBackCancel()
      })
    }
  }
}
